export const ADMIN = 'admin';
export const LAB = 'lab';
export const CLINIC = 'clinic';
export const REFRESH_BUFFER_SECONDS = 120;
